module.exports = __webpack_public_path__ + "static/photo_14-e8299de93008e2e94845732d12a5bc62.jpg";